export const PAGE_TITLE = 'Linear CPMs';

export interface LinearCpmRow {
  network: string;
  avail: string;
  status: string;
  rotation: string;
  cost_30s: number;
  aa: number;
  cpm: number;
}

const DEMOS_MALE_18_PLUS = [
  'Males 18 - 20',
  'Males 21 - 24',
  'Males 25 - 29',
  'Males 30 - 34',
  'Males 35 - 39',
  'Males 40 - 44',
  'Males 45 - 49',
  'Males 50 - 54',
  'Males 55 - 64',
  'Males 65+'
];

const DEMOS_MALE_UNDER_18 = [
  'Males 2 - 5',
  'Males 6 - 8',
  'Males 9 - 11',
  'Males 12 - 14',
  'Males 15 - 17'
];

const DEMOS_FEMALE_18_PLUS = [
  'Females 18 - 20',
  'Females 21 - 24',
  'Females 25 - 29',
  'Females 30 - 34',
  'Females 35 - 39',
  'Females 40 - 44',
  'Females 45 - 49',
  'Females 50 - 54',
  'Females 55 - 64',
  'Females 65+'
];

const DEMOS_FEMALE_UNDER_18 = [
  'Females 2 - 5',
  'Females 6 - 8',
  'Females 9 - 11',
  'Females 12 - 14',
  'Females 15 - 17'
];

export const DEFAULT_DEMOS = [...DEMOS_MALE_18_PLUS, ...DEMOS_FEMALE_18_PLUS];

const ALL_MALE_DEMOS = [...DEMOS_MALE_18_PLUS, ...DEMOS_MALE_UNDER_18];
const ALL_FEMALE_DEMOS = [...DEMOS_FEMALE_18_PLUS, ...DEMOS_FEMALE_UNDER_18];

export interface MetaDemo {
  label: string;
  demos: string[];
}

// Quick-select shortcuts. These aren't distinct demo values -- HH is the only standalone
// one; A18+/M18+/W18+ are just convenient bulk-selects for combinations of the individual
// brackets below, so they aren't offered as separate options in the demo dropdown.
export const AVAILABLE_META_DEMOS: MetaDemo[] = [
  { label: 'HH', demos: ['HH'] },
  { label: 'A18+', demos: [...DEMOS_MALE_18_PLUS, ...DEMOS_FEMALE_18_PLUS] },
  { label: 'M18+', demos: DEMOS_MALE_18_PLUS },
  { label: 'W18+', demos: DEMOS_FEMALE_18_PLUS }
];

// Every real, individually selectable demo value -- what the demo dropdown lists.
export const ALL_DEMO_OPTIONS = ['HH', ...ALL_MALE_DEMOS, ...ALL_FEMALE_DEMOS];
